import "init/jiffy";
import "common/base";

/* us */
import "components/jiffy/canada-redirect-modal/canada-redirect-modal";
import "components/jiffy/free-shipping-banner/free-shipping-banner";
import "components/jiffy/masthead/masthead";
import initMastheadRedesign2025 from "components/jiffy/masthead-redesign2025/masthead-redesign2025";
import initProductsFilter from "components/jiffy/products-filter/products-filter";
import "components/jiffy/price-line-through/price-line-through";
import "components/jiffy/app-store-badge/app-store-badge";
import initDropdownColors from "components/jiffy/dropdown-colors/dropdown-colors";
import initJiffyFirstBadges from "components/j1_badge/component";
import initBorneoCta from "components/jiffy/product-details-borneo-cta/product-details-borneo-cta";

/* application */
import "components/jiffy/product-card-badge/product-card-badge";
import "components/jiffy/badge/badge";
import "components/jiffy/promo-banner-list/promo-banner-list";
import "components/jiffy/promo-banner/promo-banner";
import "components/jiffy/button-box/button-box";
import "components/jiffy/text-box/text-box";
import "components/jiffy/check-box/check-box";
import "components/jiffy/input-box/input-box";
import "components/jiffy/radio-box/radio-box";
import "components/jiffy/flash-messages/flash-messages";
import "components/jiffy/fast-delivery-information/fast-delivery-information";
import "components/spinner/component";
import "components/jiffy/jiffy-pagination/jiffy-pagination";
import "components/kit/breadcrumbs/component";
import initSoftnessScore from "components/compositions/softness_score/component";
import initSatisfactionGuaranteed from "components/compositions/satisfaction_guaranteed/component";
import initAccessibility from "common/jiffy/accessibility";
import initModalWrapper from "components/jiffy/modal-wrapper/modal-wrapper";
import initGlobalStartDesigning from "common/jiffy/start-designing-global";
import initSocialLinks from "components/jiffy/social-icons/social-icons";
import init from "components/jiffy/product-details/product-details";
import initUpsellTransferCards from "components/jiffy/product-card-transfers/product-card-transfers";
import loadUpsellCompositionDeliveryDates from "components/jiffy/product-details-upsell-section/product-details-upsell-section";
import idleCallback from "common/utils/ui/idle_callback";
import initSeoModifications from "common/jiffy/seo-modifications";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-jiffy-first-badge")) initJiffyFirstBadges();
  if (document.querySelector(".js-social-link")) initSocialLinks();
  if (document.querySelector(".js-product-card-transfers")) initUpsellTransferCards();
  idleCallback(() => loadUpsellCompositionDeliveryDates());

  initBorneoCta();
  initAccessibility();
  initDropdownColors();
  initModalWrapper();
  initGlobalStartDesigning();
  initSoftnessScore();
  initSeoModifications();
  initMastheadRedesign2025();
  initProductsFilter();
  initSatisfactionGuaranteed({ eventName: "pdp_badge_opened" });
  init();
});
